import styled from "@emotion/styled";
import { Box } from "@mui/material";

const Layout = styled(Box)`
display:flex;
align-items:start;
 `;
const Content = styled(Box)`
 flex-grow:1;
 max-width:100%;
 padding-left:80px;
 `;
const ContentBody = styled(Box)`
 padding:16px;
 min-height:calc(100vh - 170px);
 @media screen and (max-width:600px){
 padding:12px;
}
`;
export { Layout, Content, ContentBody };